import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Modal, notification } from 'tea-component';
import LeftDataSelect from './components/LeftDataSelect';
import RightSqlEdit from './components/RightSqlEdit';
import './SqlAddSource.scss';
import { shallowEqual, useDispatch, useSelector, useIntl } from 'umi';
import {
  addCustomSqlNext,
  getVirtualTableInfo,
  saveAsCustomSql,
} from '@dbl/services/dataSource';
import { namespace } from '../../model';
import { getTableInfoList } from '@dbl/services/dataSource';
import { DateGranularity } from '@dbl/core/date';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { ChartCalculateMode } from '@dbl/core/chartEditor';
import { pick } from 'lodash-es';
import VirtualTableEditForm, { VirtualTableEditFormRef }
  from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/components/VirtualTableEditForm';
export enum Step {
  One,
  Two,
}
export interface SqlAddSourceProps {
  dataTables: any;
  isFromEdit: boolean;
  isHaveTables: boolean;
  edit?: boolean;
  sqlViewUpdateDisabled?: boolean;
  close: () => void;
  updateCallback?: (saveData: any) => void;
  saveAsCallback?: () => void;
}


export default function SqlAddSource(props: SqlAddSourceProps) {
  const { close, dataTables, isFromEdit, updateCallback, saveAsCallback, edit, sqlViewUpdateDisabled, isHaveTables } = props;
  const { formatMessage } = useIntl();
  const [sheetLoading, setSheetLoadig] = useState(true);
  const { gameCode, save_column_infos: saveColumnInfos, dataTableColumnRawColumns, sqlViewEdit } = useSelector((state: any) => ({
    gameCode: state?.datalab?.gameCode,
    save_column_infos: state[namespace]?.save_column_infos,
    modes: state[namespace]?.mode,
    dataTableColumnRawColumns: state[namespace]?.columnRawColumns,
    sqlViewEdit: edit || state[namespace]?.sqlViewEdit,
  }), shallowEqual);
  const dispatch = useDispatch();

  const [leftParams, setLeftParams] = useState({
    databaseValue: '',
    schemaValue: '',
    firstSeleted: {}
  });
  const [rightParams, setRightParams] = useState({
    sqlValue: '',
    loading: false,
    isNodata: false
  });
  const [currentStep, setCurrentStep] = useState(`${Step.One}`);
  const [editInitData, setEditInitData] = useState<any>();
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(!isFromEdit);
  const tableDataRef = useRef<Array<{ [key in string]: string }>>([]);
  const virtualTableRef = useRef<VirtualTableEditFormRef>(null);
  // const steps = [
  //   { id: `${Step.One}`, label: formatMessage({id: 'dbl_dataSource_sql_step_one_title'}) },
  //   { id: `${Step.Two}`, label: formatMessage({id: 'dbl_dataSource_sql_step_two_title'})},
  // ];

  const getLeftParams = (obj) => {
    setLeftParams(obj);
  };

  const getRightParams = (obj) => {
    setRightParams(obj);
  };

  useEffect(() => {
    if (!isFromEdit) return;
    const tableIdList = dataTables?.map(item => item?.table_id);
    getVirtualTableInfo({
      game_code: gameCode,
      table_id_list: tableIdList,
    }).then((res: any) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { database_uuid, schema, columns_info, table_name, sql, query_sql_id } = res?.[0] || {};
      setEditInitData({
        databaseValue: database_uuid || '',
        schemaValue: schema || '',
        firstSeleted: {
          column_list: columns_info ? JSON.parse(columns_info) : [],
          table_name: table_name || ''
        },
        sqlValue: sql || '',
        queryId: query_sql_id,
      });

      setLeftParams({
        databaseValue: database_uuid || '',
        schemaValue: schema || '',
        firstSeleted: {},
      });
      setRightParams({
        sqlValue: sql || '',
        loading: false,
        isNodata: false
      });
    }).catch((err) => {
      console.log('err', err);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nextBtnDisabled = useMemo(() => {
    const { sqlValue, loading, isNodata } = rightParams || {};
    const { databaseValue, schemaValue } = leftParams || {};
    return sqlValue === '' || databaseValue === '' || schemaValue === '' || loading || isNodata;
  }, [leftParams, rightParams]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const addCustomSqlNextFunc = async () => {
    
    if (!isFromEdit && isHaveTables) {
      // 已存在数据源的情况下, 修改数据源, 进行提示
      // Edit Sql View 不进行提示, 所以用 !isFromEdit判断
      const result = await Modal.confirm({
        message: formatMessage({id: 'dbl_dataSource_confirm_replace_title'}),
        description: (<div dangerouslySetInnerHTML={{ __html: formatMessage({id: 'dbl_dataSource_confirm_replace_info'})}} />),
        okText: formatMessage({id: 'dbl_common_confirm'}),
        cancelText: formatMessage({id: 'dbl_common_cancel'}),
        className: 'dbl-datasource-confirm',
        maskStyle: {zIndex: 1001},
      });
      
      if (!result) return;
    }
    
    setSubmitLoading(true);
    const { sqlValue } = rightParams || {};
    const { databaseValue, schemaValue } = leftParams || {};
    const editExtralObj = isFromEdit ? { query_id: String(editInitData?.queryId) } : '';

    const {name, saveType, label, cycle, description,} = virtualTableRef.current?.getFormValues() || {};

    const params = {
      game_code: gameCode,
      database_uuid: databaseValue,
      schema: schemaValue,
      sql: sqlValue,
      ...editExtralObj,
      name,
      label,
      cycle,
      description
    };

    const handleError = (error:any, type : string) => {
      setSubmitLoading(false);
      if (error?.code === 10011) {
        virtualTableRef.current?.setNameRepeat('dbl_virtual_table_source_name_repeat');
        return;
      }
      if (error?.code === 10014) {
        virtualTableRef.current?.setNameRepeat('dbl_virtual_table_source_name_valid');
        return;
      }
      if (error?.code === 10015) {
        virtualTableRef.current?.setNameRepeat('dbl_virtual_table_source_name_length_limit');
        return;
      }
      if (type === 'update') {
        return notification.error({description: formatMessage({id: 'dbl_virtual_table_update_fail'}), duration: 3000});
      }
      if (type === 'save') {
        return notification.error({description: formatMessage({id: 'dbl_virtual_table_save_fail'}), duration: 3000});
      }
    };
    
    if (saveType === 'update') {
      addCustomSqlNext(params).then((res) => {
        // 新建sql视图的提示文案为保存成功，编辑sql视图更新的提示文案为更新成功
        notification.success({description: formatMessage({id: isFromEdit ? 'dbl_virtual_table_update_success' : 'dbl_virtual_table_save_success'}), duration: 3000});
        setSubmitLoading(false);
        submitFunc(res, sqlValue);
      }).catch((err) => {
        console.error('虚拟表 create或update时接口报错', err);
        // 新建sql视图的错误文案为保存失败，编辑sql视图更新的错误文案为更新失败
        handleError(err , isFromEdit ? 'update' : 'save');
      });
    } else {
      // 对虚拟表 save as, 不需要替换图表数据源
      saveAsCustomSql(params).then(() => {
        saveAsCallback?.();
        notification.success({description: formatMessage({id: 'dbl_virtual_table_save_success'}), duration: 3000});
        setSubmitLoading(false);
        close();
      }).catch((err) => {
        console.error('虚拟表 save as时接口报错', err);
        handleError(err , 'save');
      });
    }
  };

  const submitFunc = (saveData: any, sql: string) => {
    if (!saveData) return;
    if (isFromEdit ? updateCallback : saveAsCallback) {
      // 编辑下是更新，新建下是另存为
      return isFromEdit ? updateCallback?.(saveData) : saveAsCallback?.();
    }
    getTableInfoList([saveData?.table_id], gameCode).then((res) => {
      dispatch({
        type: `${namespace}/setDataTableJoinRelations`,
        payload: {
          dataTableJoinRelations: [{
            connect_type: "",
            granularity: saveData?.cycle ?? DateGranularity.DAY,
            on: [],
            only_one_table: true,
            table_code: "t0",
            table_id: saveData?.table_id,
            table_name: saveData?.table_name,
            customize_name: saveData?.customize_name,
            customize_name_en: saveData?.customize_name_en,
          }],
          isOpenSelfJoin: false,
        },
      });
      const tableIds = [saveData?.table_id];

      // 针对sql模式下的缓存，更细粒度的处理
      const fullSelectedColumnsArray = res?.[0]?.column_list.map((task: { name: string; })=>task?.name);
      if (saveColumnInfos && saveColumnInfos[saveData?.table_id]) {
        saveColumnInfos[saveData?.table_id] = Object.fromEntries(
          Object.entries(saveColumnInfos[saveData?.table_id]).filter(([key]) =>
            fullSelectedColumnsArray.includes(key),
          ),
        );
      }
      dispatch({
        type: `${namespace}/setTableInfo`,
        payload: { response: res, save_column_infos: pick(saveColumnInfos, [
          ...tableIds,
          'saveRowLimits',
          'sorts',
          'chartsCfgSave',
        ]), sql },
        callback: (dataTables, mode) => {
          try {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const {column_class_list} = dataTables[0];
            const columnRawColumns: IColumnInfo[] = [];
            column_class_list.forEach((item) => {
              item.columns.forEach(column => columnRawColumns.push({...column}));
            });
            const fullColumnRawColumns = dataTableColumnRawColumns?.filter((task: { column_custom: boolean; })=>task?.column_custom);
            if (mode === ChartCalculateMode.RawColumn) {
              dispatch({
                type: `${namespace}/sqlSelectDataSetClear`,
              });
              dispatch({
                type: `${namespace}/switchChartCalculateMode`,
                payload: {
                  tables: dataTables,
                  mode,
                  columnRawColumns: [...columnRawColumns, ...fullColumnRawColumns],
                  // TODO: Sql模式自定义字段需去除???
                  // customColumns: [],
                },
              });
              
            } else {
              dispatch({
                type: `${namespace}/filterConditionByTable`,
                payload: {
                  table_ids: tableIds,
                  tables: dataTables,
                  isSqlSchemaAggregation: true,
                  forceAssignEmptyHashAnalysis: true
                },
              });
            }
          } catch (e) {
            console.error('** ', e);
          }
        }
      });
      close();
    }).catch((err) => {
      console.log('err', err);
    });
  };
  return (
    <>
      {/* <Stepper*/}
      {/*  className="dbl-add-source-stepper"*/}
      {/*  type="default"*/}
      {/*  steps={steps}*/}
      {/*  current={currentStep}*/}
      {/*/ >*/}
      <Modal.Body>

        <div className='dbl-add-source-box' style={{display: currentStep === `${Step.One}` ? 'flex' : 'none'}}>
          <LeftDataSelect getLeftParams={getLeftParams} editConfig={{
            isFromEdit,
            editInitData
          }} tableDataRef={tableDataRef}  {...{ sheetLoading, setSheetLoadig }} />
          <RightSqlEdit getRightParams={getRightParams} leftParams={leftParams} editConfig={{
            isFromEdit,
            editInitData
          }}
          replaceKeywordExtension={tableDataRef.current}
          isSpliceValue
          />
        </div>

        <VirtualTableEditForm
          style={{display: currentStep === `${Step.Two}` ? 'table' : 'none'}}
          ref={virtualTableRef}
          edit={sqlViewEdit && !sqlViewUpdateDisabled}
          isCreateNew={!isFromEdit}
          dataTables={dataTables}
          gameCode={gameCode}
          currentStep={currentStep}
          onFormValid={(valid) => {
            setIsDisabledSubmit(!valid);
          }}
        />

      </Modal.Body>
      <Modal.Footer className="add-Source-footer">
        {
          currentStep === `${Step.One}` ? (<Button
            type="primary"
            disabled={nextBtnDisabled}
            onClick={() => setCurrentStep(`${Step.Two}`)}
          >
            {formatMessage({id: 'dbl_dataSource_next_step'})}
          </Button>) : (<>
            <Button
              type="weak"
              onClick={() => {
                setCurrentStep(`${Step.One}`);
              }}
            >
              {formatMessage({id: 'dbl_dataSource_prev_step'})}
            </Button>
            <Button
              type="primary"
              /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
              onClick={addCustomSqlNextFunc}
              disabled={isDisabledSubmit}
              loading={submitLoading}
            >
              {formatMessage({id: 'dbl_dataSource_submit'})}
            </Button>

          </>)
        }
      </Modal.Footer>
    </>
  );
}